export const pushToDataLayer = (event, params = {}) => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event,
      section_name: window.location.pathname.split('/')[1],
      ...params,
    })
  }
}
